import React from 'react';

const PressPage = () => {
    return (
        <main className="press-page product-category" style={{ borderBottom: '1px solid #ececec', paddingBottom: 20 }}>
            {/* ════ MINIMAL BREADCRUMBS ════ */}
            <div className="py-4 mt-[50px]">
                <div className="container px-4">
                    <nav aria-label="breadcrumb">
                        <ol className="flex items-center gap-2 text-xs md:text-sm uppercase tracking-wider mb-0 p-0 list-none">
                            <li className="breadcrumb-item">
                                <a href="/" className="hover:text-red-600 transition-colors no-underline text-slate-500">Trang chủ</a>
                            </li>
                            <span className="opacity-30">/</span>
                            <li className="breadcrumb-item">
                                <a href="/gioi-thieu/ve-chung-toi" className="hover:text-red-600 transition-colors no-underline text-slate-500">Giới thiệu</a>
                            </li>
                            <span className="opacity-30">/</span>
                            <li className="breadcrumb-item active text-slate-900 font-bold" aria-current="page">
                                Báo Chí Nói Về Trung Anh
                            </li>
                        </ol>
                    </nav>
                </div>
            </div>

            <div className="container">
                <h1 className="heading-primary text-center" style={{ margin: '60px 0' }}>
                    <span>Báo Chí Nói Về Trung Anh</span>
                </h1>
                <p className="text-center">
                    Tổng hợp những bài viết, phóng sự và tin tức từ báo chí, truyền hình về Trung Anh Garage.
                </p>
            </div>
        </main>
    );
};

export default PressPage;




